import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, PlayCircle } from 'lucide-react';

const Hero = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20,
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleDemoTour = () => {
    alert('Demo tour viewer will be integrated here. This is a placeholder for the interactive 360° tour experience.');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Animated Background */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1593508512255-86ab42a8e620?w=1920)',
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px) scale(1.1)`,
            transition: 'transform 0.5s ease-out',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
        
        {/* Grid Overlay */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `
              repeating-linear-gradient(0deg, transparent, transparent 1px, #00FFD1 1px, #00FFD1 2px),
              repeating-linear-gradient(-90deg, transparent, transparent 1px, #00FFD1 1px, #00FFD1 2px)
            `,
            backgroundSize: '80px 80px',
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-[7.6923%] py-32 text-center">
        <div className="space-y-8 animate-fade-in">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full">
            <span className="w-2 h-2 bg-[#00FFD1] rounded-full animate-pulse" />
            <span className="text-white/90 text-sm font-medium">360° Virtual Tour Technology</span>
          </div>

          {/* Main Headline */}
          <h1 className="display-huge text-white max-w-5xl mx-auto">
            Let Customers Walk Through Your Business{' '}
            <span className="text-[#00FFD1]">Before They Visit</span>
          </h1>

          {/* Subtext */}
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            High-resolution 360° Virtual Tours for Restaurants, Hotels, Real Estate, 
            Schools, Resorts, and Commercial Spaces in Manipal & Udupi.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-8">
            <Button 
              onClick={handleDemoTour}
              className="btn-secondary group"
            >
              <PlayCircle className="w-5 h-5" />
              View Demo Tour
            </Button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="btn-primary group"
            >
              Get a Virtual Tour
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-16 max-w-4xl mx-auto">
            {[
              { value: '150+', label: 'Businesses Served' },
              { value: '320+', label: 'Tours Created' },
              { value: '15+', label: 'Cities Covered' },
              { value: '145+', label: 'Happy Clients' },
            ].map((stat, index) => (
              <div 
                key={index} 
                className="text-center p-6 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00FFD1]/50 transition-all duration-400"
              >
                <div className="display-medium text-[#00FFD1] mb-2">{stat.value}</div>
                <div className="body-small text-white/70">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/60 text-sm">Scroll to explore</span>
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#00FFD1] rounded-full" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
